import { Component, OnInit } from '@angular/core';
import { DigitalBarcodeServiceService } from '../digital-barcode-service.service';
import { ActivatedRoute } from "@angular/router";
import { SharedserviceService} from '../sharedservice.service';
import { openDB, deleteDB } from 'idb'

import {
  trigger,
  state,
  style,
  animate,
  transition,
  // ...
} from '@angular/animations';

@Component({
  selector: 'app-barcode-details',
  templateUrl: './barcode-details.component.html',
  styleUrls: ['./barcode-details.component.less'],
  animations: [ trigger('fade', [
    transition(':enter', [
      style({ opacity: 0 ,position: 'relative', top: '50%'}),
      animate('1s', style({ opacity: 1, position: 'relative',top: 0 })),
    ]),
    ])
  ]
})
export class BarcodeDetailsComponent implements OnInit {

  barcode: any;
  encryptedData: any;
  userType: any;
  paramCookie: any;
  displayLoader: boolean;
  errorBlock: boolean;

  constructor( private DigitalBarcodeServiceService: DigitalBarcodeServiceService,
  private route: ActivatedRoute, private SharedserviceService: SharedserviceService) { 
    this.displayLoader = true;
  }

  ngOnInit(): void {
    this.route.queryParamMap.subscribe(async queryParams => {
      this.encryptedData = queryParams.get("d");
        if(this.encryptedData){
          this.getUsers(this.encryptedData);
        }
        else{
          try{
            const db = await openDB('tokenDb');
            const transaction = db.transaction('token');
            const store = transaction.objectStore('token');
            const dbVal = await store.get('param');
            this.getUsers(dbVal);
            transaction.done;
          }
          catch(error){
            console.log(error);
          }
        }
    });
  }

  getUsers(encryptedData: any) {
    if(encryptedData){
      this.DigitalBarcodeServiceService.getUserDetails(encryptedData).subscribe(data => {this.barcode = data,
        this.displayLoader = false,
        this.errorBlock = false;
        this.setAccountType(this.barcode.accountSummary.ruleType,this.barcode.accountSummary.cashOnly)
      },
        error => {
          this.displayLoader = false;
          this.errorBlock = true;
        }
      );
    }
  }
  setAccountType(ruletype: any,cashOnly: any) {
    if(ruletype === '05'){
      this.SharedserviceService.setAccountType('Charge Account')
    }
    else if(cashOnly === 'Y'){
      this.SharedserviceService.setAccountType('Cash Account')
    }
    else{
      this.SharedserviceService.setAccountType('National Account')
    }
  }

}
